export const pillTagStyle = {
  background: "color-mix(in srgb, var(--ant-primary-color) 8%, white)",
  color: "#344054",
  border:
    "1px solid color-mix(in srgb, var(--ant-primary-color) 14%, #eaecf0)",
  borderRadius: 4,
  padding: "6px 14px",
  fontSize: 13,
  fontWeight: 500,
  margin: 0,
  lineHeight: 1.4,
};

export const nestedGroupBorder = {
  paddingLeft: 12,
  borderLeft: "1px solid #f2f4f7",
};
